export class DetalheModel{

    entryType: string;
    entityModel: any;


    constructor(entryType: string, entityModel: any) {
        this.entryType = entryType;
        this.entityModel = entityModel;
    }
}
